<template>
  <div id="appupkid">
    <router-view/>
    <div v-if="loading" class="loading">...</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'loading'
    ])
  }
}
</script>

<style lang="scss" scoped>
#appupkid {
  display: flex;
  flex-direction: column;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
.loading {
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 0.14rem;
  color: #bbbbbb;
}
</style>
